// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nova-obra-page {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.header-actions {
    display: flex;
    gap: 10px;
}

.obra-form {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow: hidden;
}

.form-layout {
    display: grid;
    grid-template-columns: 480px 1fr;
    gap: 20px;
    flex: 1 1;
    overflow: hidden;
}

.form-section {
    background: white;
    padding: 10px;
    /* Reduzido de 15px */
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    /* Forçar remoção de scroll lateral */
}

.map-section {
    padding: 10px;
    display: flex;
    flex-direction: column;
}

.map-tools {
    display: flex;
    gap: 8px;
    margin: 10px 0;
    padding: 8px;
    background: #f8f9fa;
    border-radius: 4px;
    flex-wrap: wrap;
}

.map-container {
    flex: 1 1;
    min-height: 340px;
    /* Reduzido mais um pouco */
    border-radius: 8px;
    border: 1px solid #ddd;
    z-index: 1;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Form Elements */
.form-group {
    margin-bottom: 8px;
}

.form-group label {
    display: block;
    margin-bottom: 2px;
    font-weight: 500;
    color: #444;
    font-size: 11px;
    /* Reduzido de 13px */
}

.form-group input,
.form-group select,
.form-group textarea {
    width: 100%;
    padding: 4px 8px;
    /* Mais compacto */
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 13px;
    box-sizing: border-box;
    /* Crucial para não transbordar */
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    /* Reduzido de 15px */
    margin-bottom: 5px;
}

/* Work Items */
.work-items-grid {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 300px;
    /* Reduzido para evitar scroll da página */
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 5px;
    margin-top: 5px;
    border: 1px solid #eee;
    padding: 5px;
    border-radius: 4px;
}

/* Custom scrollbar */
.work-items-grid::-webkit-scrollbar {
    width: 4px;
}

.work-items-grid::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.work-items-grid::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

.work-category h4 {
    margin: 5px 0 3px 0;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: #888;
    border-bottom: 1px solid #eee;
}

.work-checkbox {
    display: flex;
    align-items: center;
    padding: 2px 4px;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
}

.work-checkbox .label {
    flex: 1 1;
    font-size: 12px;
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
    /* Forçar ellipsis mais cedo */
}

/* Map Toolbar */
.map-toolbar {
    display: flex;
    gap: 5px;
    padding: 5px;
    background: #f8f9fa;
    border: 1px solid #ddd;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    align-items: center;
}

.toolbar-label {
    font-size: 12px;
    font-weight: bold;
    color: #666;
    margin-right: 5px;
}

.tool-btn {
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
}

.tool-btn:hover {
    background: #eee;
}

.tool-btn.active {
    background: #007bff;
    color: white;
    border-color: #0056b3;
}

.tool-btn.tool-clear {
    background: #fff;
    color: #dc3545;
    border-color: #dc3545;
}

.tool-btn.tool-clear:hover {
    background: #dc3545;
    color: white;
}

.divider {
    width: 1px;
    height: 20px;
    background: #ddd;
    margin: 0 5px;
}

.clear-btn {
    margin-left: auto;
    color: #dc3545;
}

.map-info {
    font-size: 11px;
    color: #666;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
}

/* Actions */
.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 10px;
    border-top: 1px solid #eee;
}

.btn-primary {
    background: #2196F3;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
}

.btn-secondary {
    background: #f5f5f5;
    color: #333;
    border: 1px solid #ddd;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-primary:hover {
    background: #1976D2;
}

.btn-secondary:hover {
    background: #e0e0e0;
}

.custom-map-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/NovaObra.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,8CAA8C;AAClD;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;;;IAGI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".nova-obra-page {\r\n    padding: 20px;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.page-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.header-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.obra-form {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    overflow: hidden;\r\n}\r\n\r\n.form-layout {\r\n    display: grid;\r\n    grid-template-columns: 480px 1fr;\r\n    gap: 20px;\r\n    flex: 1;\r\n    overflow: hidden;\r\n}\r\n\r\n.form-section {\r\n    background: white;\r\n    padding: 10px;\r\n    /* Reduzido de 15px */\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    /* Forçar remoção de scroll lateral */\r\n}\r\n\r\n.map-section {\r\n    padding: 10px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.map-tools {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin: 10px 0;\r\n    padding: 8px;\r\n    background: #f8f9fa;\r\n    border-radius: 4px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.map-container {\r\n    flex: 1;\r\n    min-height: 340px;\r\n    /* Reduzido mais um pouco */\r\n    border-radius: 8px;\r\n    border: 1px solid #ddd;\r\n    z-index: 1;\r\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Form Elements */\r\n.form-group {\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 2px;\r\n    font-weight: 500;\r\n    color: #444;\r\n    font-size: 11px;\r\n    /* Reduzido de 13px */\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n    width: 100%;\r\n    padding: 4px 8px;\r\n    /* Mais compacto */\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 13px;\r\n    box-sizing: border-box;\r\n    /* Crucial para não transbordar */\r\n}\r\n\r\n.form-row {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 8px;\r\n    /* Reduzido de 15px */\r\n    margin-bottom: 5px;\r\n}\r\n\r\n/* Work Items */\r\n.work-items-grid {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n    max-height: 300px;\r\n    /* Reduzido para evitar scroll da página */\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    padding-right: 5px;\r\n    margin-top: 5px;\r\n    border: 1px solid #eee;\r\n    padding: 5px;\r\n    border-radius: 4px;\r\n}\r\n\r\n/* Custom scrollbar */\r\n.work-items-grid::-webkit-scrollbar {\r\n    width: 4px;\r\n}\r\n\r\n.work-items-grid::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n}\r\n\r\n.work-items-grid::-webkit-scrollbar-thumb {\r\n    background: #ccc;\r\n    border-radius: 3px;\r\n}\r\n\r\n.work-category h4 {\r\n    margin: 5px 0 3px 0;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    color: #888;\r\n    border-bottom: 1px solid #eee;\r\n}\r\n\r\n.work-checkbox {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 2px 4px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.work-checkbox .label {\r\n    flex: 1;\r\n    font-size: 12px;\r\n    line-height: 1.1;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 160px;\r\n    /* Forçar ellipsis mais cedo */\r\n}\r\n\r\n/* Map Toolbar */\r\n.map-toolbar {\r\n    display: flex;\r\n    gap: 5px;\r\n    padding: 5px;\r\n    background: #f8f9fa;\r\n    border: 1px solid #ddd;\r\n    border-bottom: none;\r\n    border-radius: 4px 4px 0 0;\r\n    align-items: center;\r\n}\r\n\r\n.toolbar-label {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    color: #666;\r\n    margin-right: 5px;\r\n}\r\n\r\n.tool-btn {\r\n    background: white;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.tool-btn:hover {\r\n    background: #eee;\r\n}\r\n\r\n.tool-btn.active {\r\n    background: #007bff;\r\n    color: white;\r\n    border-color: #0056b3;\r\n}\r\n\r\n.tool-btn.tool-clear {\r\n    background: #fff;\r\n    color: #dc3545;\r\n    border-color: #dc3545;\r\n}\r\n\r\n.tool-btn.tool-clear:hover {\r\n    background: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.divider {\r\n    width: 1px;\r\n    height: 20px;\r\n    background: #ddd;\r\n    margin: 0 5px;\r\n}\r\n\r\n.clear-btn {\r\n    margin-left: auto;\r\n    color: #dc3545;\r\n}\r\n\r\n.map-info {\r\n    font-size: 11px;\r\n    color: #666;\r\n    margin-top: 5px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n/* Actions */\r\n.form-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n    padding-top: 10px;\r\n    border-top: 1px solid #eee;\r\n}\r\n\r\n.btn-primary {\r\n    background: #2196F3;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 4px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-secondary {\r\n    background: #f5f5f5;\r\n    color: #333;\r\n    border: 1px solid #ddd;\r\n    padding: 8px 16px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-primary:hover {\r\n    background: #1976D2;\r\n}\r\n\r\n.btn-secondary:hover {\r\n    background: #e0e0e0;\r\n}\r\n\r\n.custom-map-icon {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: none;\r\n    border: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
